import {
  ComponentBox,
  ComponentBoxHeaderFooter,
  EmptyResult,
  LoadingSpinner,
  loginContainer,
} from '@wallaby-ui/core';
import classNames from 'classnames';
import {isEmpty, isUndefined} from 'lodash';
import PropTypes from 'prop-types';
import * as React from 'react';
import {defineMessages} from 'react-intl';
import {File as FileModel} from 'src/js/model/file';

import styles from './PdfViewer.less';
import PdfViewerToolbar from './PdfViewerToolbar';

export const I18N = defineMessages({
  LOADING: {
    id: 'document.pdf.loading',
    defaultMessage: 'Loading PDF ...',
    description: 'text for loading spinner in pdf viewer box',
  },
});

class PdfViewer extends React.PureComponent {
  componentDidUpdate(prevProps) {
    const {currentPdf, document, visiblePdfViewers} = this.props;
    if (this.pdfElem && !isEmpty(currentPdf)) {
      const justLoaded = isUndefined(prevProps.currentPdf);
      const documentChanged =
        prevProps.document.getDocumentId() !== document.getDocumentId();
      prevProps.showPdf(
        this.pdfElem,
        currentPdf,
        justLoaded,
        visiblePdfViewers[document.getDocumentId()],
        prevProps.visiblePdfViewers[document.getDocumentId()],
        documentChanged
      );
    }
  }

  render() {
    const {
      currentPdf,
      initEvent,
      isLoadingPdfCounter,
      onRotate,
      onSetPage,
      onZoom,
      removeEvent,
    } = this.props;
    return (
      <div
        className={styles.dlPdfViewer}
        ref={(pdfElem) => {
          this.pdfElem = pdfElem;
        }}
      >
        <div
          className={classNames(
            'dlLoadingSpinnerContainer',
            'dlFlexBoxContainerInContainer',
            {dlLoadingSpinnerParent: isLoadingPdfCounter > 0}
          )}
        >
          <LoadingSpinner
            isVisible={isLoadingPdfCounter > 0}
            text={I18N.LOADING.id}
          />
          {!isEmpty(currentPdf) ? (
            <ComponentBoxHeaderFooter>
              <PdfViewerToolbar
                onSetPage={onSetPage}
                onRotate={onRotate}
                onZoom={onZoom}
                initEvent={initEvent}
                removeEvent={removeEvent}
              />
            </ComponentBoxHeaderFooter>
          ) : null}
          <div className={'content-wrap__pdf'}>
            {!isEmpty(currentPdf) ? (
              <ComponentBox>
                <div className={'container-pdf__viewer-wrapper'}>
                  <div
                    className={'container-pdf__viewer-container'}
                    tabIndex={'0'}
                  >
                    <div id={'viewer'} className={'pdfViewer'} />
                  </div>
                </div>
              </ComponentBox>
            ) : (
              <EmptyResult />
            )}
          </div>
        </div>
      </div>
    );
  }
}

PdfViewer.displayName = 'PdfViewer';

PdfViewer.propTypes = {
  currentPdf: PropTypes.objectOf(PropTypes.any),
  document: PropTypes.instanceOf(FileModel).isRequired,
  initEvent: PropTypes.func.isRequired,
  isLoadingPdfCounter: PropTypes.number,
  onSetPage: PropTypes.func.isRequired,
  onRotate: PropTypes.func.isRequired,
  onZoom: PropTypes.func.isRequired,
  removeEvent: PropTypes.func.isRequired,
  showPdf: PropTypes.func.isRequired,
  visiblePdfViewers: PropTypes.objectOf(PropTypes.any),
};

PdfViewer.defaultProps = {
  currentPdf: {},
  isLoadingPdfCounter: 0,
  visiblePdfViewers: {},
};

export default PdfViewer;
